import React, { useCallback } from 'react';
import styled from 'astroturf/react';

import { Options as ClickTrackingOptions } from 'js/utils/trackClick';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';

import { ModalPage } from '../types';
import { BackButton } from '../components/BackButton';
import { CenteredDiv } from '../components/CenteredDiv';
import { VerticalSpacer } from '../components/VerticalSpacer';

type Props = {
  setPage: React.Dispatch<React.SetStateAction<ModalPage>>;
  show: boolean;
  clickTrackingContext?: Partial<ClickTrackingOptions>;
};

const Container = styled.div<{ show: boolean }>`
  display: none;
  flex-direction: column;

  &.show {
    display: flex;
  }
`;

const MessageText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  max-width: 540px;
  text-align: center;
  line-height: 1.5;
`;

export const FacebookDisabledPage: React.FC<Props> = (props) => {
  const { setPage, show } = props;

  const onBackClick = useCallback(() => {
    setPage('buttons');
  }, [setPage]);

  return (
    <Container show={show}>
      <BackButton onClick={onBackClick} />
      <VerticalSpacer height={24} />
      <Heading size="md" fontFamily="serif">
        Facebook login is no longer available
      </Heading>
      <VerticalSpacer height={16} />
      <CenteredDiv>
        <MessageText>
          <Body size="xl">Reset your password to access your account:</Body>
          <ButtonLink href="/reset_password">Reset Password</ButtonLink>
        </MessageText>
      </CenteredDiv>
      <VerticalSpacer height={40} />
    </Container>
  );
};
